import { render } from "./UserOKServiceModal.vue?vue&type=template&id=ebb73b52&scoped=true"
import script from "./UserOKServiceModal.vue?vue&type=script&lang=js"
export * from "./UserOKServiceModal.vue?vue&type=script&lang=js"

import "./UserOKServiceModal.vue?vue&type=style&index=0&id=ebb73b52&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb73b52"]])

export default __exports__